<template>
  <transition appear>
    <div>
      <el-dialog
        title="Add a new Premium Activation"
        :visible.sync="premiumActDialogVisible"
        width="50%">

        <el-form
          class="mktAct__form"
          ref="newPremiumActForm"
          :model="newPremiumAct"
          :rules="premiumActRules"
          label-width="120px"
        >
          <el-form-item label="Status">
            <el-radio-group v-model="newPremiumAct.status">
              <el-radio-button label="Off"></el-radio-button>
              <el-radio-button label="Stand by"></el-radio-button>
              <el-radio-button label="On"></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="Banner name" prop="name">
            <el-input v-model="newPremiumAct.name"></el-input>
          </el-form-item>
          <el-form-item label="Tech name" prop="techName">
            <el-input v-model="newPremiumAct.techName"></el-input>
          </el-form-item>
          <el-form-item label="PS versions">
            <el-autocomplete
              class="inline-input"
              v-model="newPremiumAct.psVersionFrom"
              :fetch-suggestions="querySearch"
              placeholder="Please Input"
              @select="handleSelect"
            ></el-autocomplete>
            to
            <el-autocomplete
              class="inline-input"
              v-model="newPremiumAct.psVersionTo"
              :fetch-suggestions="querySearch"
              placeholder="Please Input"
              @select="handleSelect"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item class="mktAct__form__languages" label="Languages" ref="languages">
            <el-select
              v-model="newPremiumAct.languages"
              @change="onChangeLanguages"
              name="languages"
              filterable
              multiple
              placeholder=""
            >
              <el-option
                v-for="item in langOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <div class="mktAct__form__language" v-for="(value, index) in newPremiumAct.contents">
              <el-form-item
              :label="index.toUpperCase() + ' (' + value.length + '/80)'"
              :prop="'contents[' + index + ']'"
              :rules="[
                { required: true, message: 'Add a content or remove this language', trigger: 'blur' },
                { max: 80, message: 'Length must be less than 80', trigger: 'blur' }
              ]"
            >
                <el-input
                  type="textarea"
                  v-model="newPremiumAct.contents[index]"
                ></el-input>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item class="mktAct__form__visibility" label="Visibility" ref="visibility">
            <el-select
              v-model="newPremiumAct.visibility"
              name="visibility"
              filterable
              multiple
              placeholder="Worldwide"
            >
              <el-option-group
                v-for="group in visibilityOptions"
                :key="group.label"
                :label="group.label">
                <el-option
                  v-for="item in group.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item class="mktAct__form__visibility__shortcut">
            <el-button v-on:click="newPremiumAct.visibility=zones.AF.concat(zones.AS, zones.EU, zones.NA, zones.OC, zones.SA)">Worldwide</el-button>
            <el-button type="info" v-on:click="newPremiumAct.visibility=zones.AF">Africa</el-button>
            <el-button type="warning" v-on:click="newPremiumAct.visibility=zones.AS">Asia</el-button>
            <el-button type="primary" v-on:click="newPremiumAct.visibility=zones.EU">Europe</el-button>
            <el-button type="danger" v-on:click="newPremiumAct.visibility=zones.NA">N. America</el-button>
            <el-button type="success" v-on:click="newPremiumAct.visibility=zones.OC">Oceania</el-button>
            <el-button type="danger" v-on:click="newPremiumAct.visibility=zones.SA">S. America</el-button>
            <el-button v-on:click="newPremiumAct.visibility=['']"><i class="toolbar__icon el-icon-close"></i></el-button>
          </el-form-item>
          <el-form-item label="Logo" class="mktAct__form__logo">
            <el-upload
              class="upload-demo"
              :action="`${apiUrl}/premium-activations/logo`"
              ref="logoUpload"
              :on-change="onChangeLogo"
              :auto-upload="false"
              :multiple="false"
              :limit="1"
              list-type="picture">
              <el-button size="small" type="primary">Click to upload</el-button>
              <div slot="tip" class="el-upload__tip">png file with a size less than 500kb</div>
            </el-upload>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="addPremiumActivation"
            :loading="saving === true"
          >
            Confirm
          </el-button>
          <el-button @click="resetForm('newPremiumActForm')">Reset</el-button>
        </span>
      </el-dialog>

      <el-row :gutter="24">
        <el-col :span="14" :offset="5">
          <div class="grid-content">
            <div class="mainToolbar pull-right">
              <i @click="premiumActDialogVisible = true; deletion.active = false; editing = false" class="pointer mainToolbar__icon el-icon-plus"></i>
              <i @click="deletion.active = !deletion.active; editing = false" class="pointer mainToolbar__icon el-icon-delete"></i>
            </div>
            <div class="breadcrumb">
              <h1 class="breadcrumb__h1">Marketing Activities</h1>
              <h1 class="breadcrumb__h2">Premium Activation</h1>
            </div>
          </div>
          <div class="grid-content">
            <el-input
              class="searchContent"
              placeholder="Search"
              prefix-icon="el-icon-search"
              @keyup.native="seachActivity">
            </el-input>
          </div>
          <el-collapse class="filtersCollapse">
            <el-collapse-item title="Filters" name="1">
              <div class="grid-content filtersCollapse__tabpanel">
                <el-form ref="form" :model="filter" label-width="120px">
                  <el-form-item label="Languages">
                    <el-select
                      v-model="filter.languages"
                      @change="onChangeLanguages"
                      name="languages"
                      filterable
                      multiple
                      placeholder="All languages"
                    >
                      <el-option
                        v-for="item in langOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="Countries">
                    <el-select
                      v-model="filter.countries"
                      name="visibility"
                      filterable
                      multiple
                      placeholder="Worldwide"
                    >
                      <el-option-group
                        v-for="group in visibilityOptions"
                        :key="group.label"
                        :label="group.label">
                        <el-option
                          v-for="item in group.options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-option-group>
                    </el-select>
                  </el-form-item>
                  <el-form-item class="mktAct__form__visibility__shortcut">
                    <el-button v-on:click="filter.countries=zones.AF.concat(zones.AS, zones.EU, zones.NA, zones.OC, zones.SA)">Worldwide</el-button>
                    <el-button type="info" v-on:click="filter.countries=zones.AF">Africa</el-button>
                    <el-button type="warning" v-on:click="filter.countries=zones.AS">Asia</el-button>
                    <el-button type="primary" v-on:click="filter.countries=zones.EU">Europe</el-button>
                    <el-button type="danger" v-on:click="filter.countries=zones.NA">N. America</el-button>
                    <el-button type="success" v-on:click="filter.countries=zones.OC">Oceania</el-button>
                    <el-button type="danger" v-on:click="filter.countries=zones.SA">S. America</el-button>
                    <el-button v-on:click="filter.countries=['']"><i class="toolbar__icon el-icon-close"></i></el-button>
                  </el-form-item>
                  <el-form-item label="Status">
                    <el-checkbox-group v-model="filter.status">
                      <el-checkbox label="Off" border></el-checkbox>
                      <el-checkbox label="Stand by" border></el-checkbox>
                      <el-checkbox label="On" border></el-checkbox>
                    </el-checkbox-group>
                  </el-form-item>
                  <el-form-item class="filtersCollapse__tabpanel__applyBlock">
                    <el-button type="primary" @click="onApplyFilters">Apply</el-button>
                    <el-button @click="onClearFilters">Clear</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-collapse-item>
          </el-collapse>
          <div class="grid-content pageContent" v-if="deletion.active">
            <el-button
              @click="deleteActivities"
              v-show="deletion.activities.length"
              :loading="deletion.activities.loading === true"
              type="danger"
              plain
            >
              Delete
            </el-button>
            <el-button v-show="!deletion.activities.length" type="danger" plain disabled>Delete</el-button>
            <el-button @click="deletion.active = false" plain>Cancel</el-button>
          </div>

          <el-row :gutter="24" class="pageContent">
            <el-col :span="24">
              <div v-show="!premiumActs.length" class="spinner">
                <div class="double-bounce1"></div>
                <div class="double-bounce2"></div>
              </div>

              <div v-for="(premiumAct, index) in premiumActs">
                <div
                  class="mktAct"
                  v-bind:class="{
                    'mktAct--active': premiumAct.status==='On',
                    'mktAct--pending': premiumAct.status==='Stand by',
                    'mktAct--editing': editing===index
                  }"
                  v-show="search.hiddenActivities.indexOf(index) === -1 && filter.hiddenActivities.indexOf(index) === -1"
                >
                  <div class="mktAct__header" v-on:click="editing = editing === false ? index : false">
                    <div class="mktAct__header__logo" :style="{ backgroundImage: `url('${premiumAct.logoUrl}')` }"></div>
                    <h1 class="mktAct__header__partnerName">{{ premiumAct.name }}</h1>
                    <el-checkbox @change="onChangeDeleteCheckbox(index, $event)" v-if="deletion.active" class="mktAct__header__deleteCheckbox"></el-checkbox>
                  </div>
                  <el-collapse-transition>
                    <div v-if="editing===index" class="mktAct__edit">
                      <el-form class="mktAct__form" ref="form" :model="premiumAct" label-width="120px">
                        <el-form-item label="Status">
                          <el-radio-group v-model="premiumAct.status">
                            <el-radio-button label="Off"></el-radio-button>
                            <el-radio-button label="Stand by"></el-radio-button>
                            <el-radio-button label="On"></el-radio-button>
                          </el-radio-group>
                        </el-form-item>
                        <el-form-item label="Banner name">
                          <el-input v-model="premiumAct.name"></el-input>
                        </el-form-item>
                        <el-form-item label="Tech name">
                          <el-input v-model="premiumAct.techName"></el-input>
                        </el-form-item>
                        <el-form-item label="PS versions">
                          <el-autocomplete
                            class="inline-input"
                            v-model="premiumAct.psVersionFrom"
                            :fetch-suggestions="querySearch"
                            placeholder="Please Input"
                            @select="handleSelect"
                          ></el-autocomplete>
                          to
                          <el-autocomplete
                            class="inline-input"
                            v-model="premiumAct.psVersionTo"
                            :fetch-suggestions="querySearch"
                            placeholder="Please Input"
                            @select="handleSelect"
                          ></el-autocomplete>
                        </el-form-item>
                        <el-form-item class="mktAct__form__languages" label="Languages" ref="languages">
                          <el-select
                            v-model="premiumAct.languages"
                            @change="onChangeLanguages"
                            name="languages"
                            filterable
                            multiple
                            placeholder=""
                          >
                            <el-option
                              v-for="item in langOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="">
                          <div class="mktAct__form__language" v-for="(value, index) in premiumAct.contents">
                            <el-form-item
                            :label="index.toUpperCase() + ' (' + value.length + '/80)'"
                            :prop="'contents[' + index + ']'"
                            :rules="[
                              { required: true, message: 'Add a content or remove this language', trigger: 'blur' },
                              { max: 80, message: 'Length must be less than 80', trigger: 'blur' }
                            ]"
                            >
                              <el-input
                                type="textarea"
                                v-model="premiumAct.contents[index]"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </el-form-item>
                        <el-form-item class="mktAct__form__visibility" label="Visibility" ref="visibility">
                          <el-select v-model="premiumAct.visibility" name="visibility" filterable multiple placeholder="Worldwide">
                            <el-option-group
                              v-for="group in visibilityOptions"
                              :key="group.label"
                              :label="group.label">
                              <el-option
                                v-for="item in group.options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                              </el-option>
                            </el-option-group>
                          </el-select>
                        </el-form-item>
                        <el-form-item class="mktAct__form__visibility__shortcut">
                          <el-button v-on:click="premiumAct.visibility=zones.AF.concat(zones.AS, zones.EU, zones.NA, zones.OC, zones.SA)">Worldwide</el-button>
                          <el-button type="info" v-on:click="premiumAct.visibility=zones.AF">Africa</el-button>
                          <el-button type="warning" v-on:click="premiumAct.visibility=zones.AS">Asia</el-button>
                          <el-button type="primary" v-on:click="premiumAct.visibility=zones.EU">Europe</el-button>
                          <el-button type="danger" v-on:click="premiumAct.visibility=zones.NA">N. America</el-button>
                          <el-button type="success" v-on:click="premiumAct.visibility=zones.OC">Oceania</el-button>
                          <el-button type="danger" v-on:click="premiumAct.visibility=zones.SA">S. America</el-button>
                          <el-button v-on:click="premiumAct.visibility=['']"><i class="toolbar__icon el-icon-close"></i></el-button>
                        </el-form-item>
                        <el-form-item label="Logo" class="mktAct__form__logo">
                          <el-upload
                            class="upload-demo"
                            :action="`${apiUrl}/premium-activations/logo`"
                            :ref="`logoUpload${index}`"
                            :on-change="onChangeLogo"
                            :auto-upload="false"
                            :multiple="false"
                            :limit="1"
                            list-type="picture">
                            <el-button size="small" type="primary">Click to upload</el-button>
                            <div slot="tip" class="el-upload__tip">png file with a size less than 500kb</div>
                          </el-upload>
                        </el-form-item>
                        <el-form-item>
                          <el-button
                            type="primary"
                            :loading="saving === editing"
                            @click="updatePremiumActivation"
                          >Save</el-button>
                          <el-button v-on:click="editing=false">Cancel</el-button>
                        </el-form-item>
                      </el-form>
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </transition>
</template>

<script>
import axios from 'axios';
import languagesList from '../utils/languages';
import { zones, countriesListByRegion } from '../utils/countries';

export default {
  name: 'MktActList',
  data() {
    return {
      env: process.env, // Environement variables
      deletion: {
        activities: [],
        loading: false,
        active: false,
      },
      search: {
        hiddenActivities: [],
        query: '',
      },
      langOptions: languagesList,
      zones,
      visibilityOptions: countriesListByRegion,
      premiumActDialogVisible: false,
      premiumActRules: {
        name: [
          { required: true, message: 'Please input Activity name', trigger: 'blur' },
        ],
        techName: [
          { required: true, message: 'Please input Activity Tech name', trigger: 'blur' },
        ],
        content: [
          {
            required: true, message: 'Please input a content or remove this language', trigger: 'blur',
          },
          {
            max: 80, message: 'length should be less than 80', trigger: 'blur',
          },
        ],
      },
      newPremiumAct: {
        status: 'Off',
        name: '',
        techName: '',
        psVersionFrom: '',
        psVersionTo: '',
        languages: ['EN'],
        contents: { EN: '' },
        visibility: [],
      },
      saving: false,
      premiumActs: [],
      editing: false,
      psVersions: [
        { value: '1.0.0.0' },
        { value: '1.1.0.0' },
        { value: '1.2.0.0' },
        { value: '1.2.5.0' },
        { value: '1.3.0.0' },
        { value: '1.3.0.1' },
        { value: '1.4.0.1' },
        { value: '1.4.0.10' },
        { value: '1.4.7.0' },
        { value: '1.5.0.0' },
        { value: '1.5.0.17' },
        { value: '1.5.3.1' },
        { value: '1.5.4.1' },
        { value: '1.5.5.0' },
        { value: '1.5.6.0' },
        { value: '1.5.6.1' },
        { value: '1.5.6.3' },
        { value: '1.6.0.0' },
        { value: '1.6.0.14' },
        { value: '1.6.0.4' },
        { value: '1.6.0.5' },
        { value: '1.6.0.6' },
        { value: '1.6.1.0' },
        { value: '1.6.1.1' },
        { value: '1.6.1.4' },
        { value: '1.6.1.5' },
        { value: '1.6.1.12' },
        { value: '1.6.1.15' },
        { value: '1.6.1.17' },
        { value: '1.6.1.24' },
        { value: '1.7.0.2' },
        { value: '1.7.0.3' },
        { value: '1.7.0.4' },
        { value: '1.7.0.5' },
        { value: '1.7.0.6' },
        { value: '1.7.1.0' },
        { value: '1.7.1.1' },
        { value: '1.7.1.2' },
        { value: '1.7.2.0' },
        { value: '1.7.2.1' },
        { value: '1.7.2.2' },
        { value: '1.7.2.3' },
        { value: '1.7.2.4' },
        { value: '1.7.2.5' },
        { value: '1.7.3.0' },
        { value: '1.7.3.1' },
        { value: '1.7.3.2' },
        { value: '1.7.3.3' },
        { value: '1.7.3.4' },
        { value: '1.7.4.0' },
        { value: '1.7.4.1' },
        { value: '1.7.4.2' },
        { value: '1.7.4.3' },
        { value: '1.7.4.4' },
        { value: '1.7.5.0' },
        { value: '1.7.5.1' },
        { value: '1.7.5.2' },
        { value: '1.7.6.0' },
        { value: '1.7.6.1' },
        { value: '1.7.6.2' },
        { value: '1.7.6.3' },
        { value: '1.7.6.4' },
        { value: '1.7.6.5' },
        { value: '1.7.6.6' },
        { value: '1.7.6.7' },
        { value: '1.7.6.8' },
        { value: '1.7.6.9' },
        { value: '1.7.7.0' },
      ],
      filter: {
        languages: [],
        countries: [],
        hiddenActivities: [],
        status: ['Off', 'Stand by', 'On'],
      },
    };
  },
  mounted() {
    // Get the premium activations list
    axios({
      method: 'GET',
      url: `${this.apiUrl}/premium-activations`,
      headers: {
        Authorization: this.$idToken,
      },
    })
    .then((result) => {
      console.log('result:', result);
      this.premiumActs = result.data;
    }, (error) => {
      console.error(error);
    });
  },
  methods: {
    /**
     * When the user type a seach, filter the activities by matching name or
     * tech id
     * @param {Event} e
     */
    seachActivity(e) {
      const query = e.target.value.toLowerCase();
      const matchs = [];
      for (let i = 0; i < this.premiumActs.length; i++) {
        const name = this.premiumActs[i].name.toLowerCase();
        const techName = this.premiumActs[i].techName.toLowerCase();
        if (name.indexOf(query) === -1 && techName.indexOf(query) === -1) {
          matchs.push(i);
        }
      }

      this.search.hiddenActivities = matchs;
    },
    /**
     * On click on a checkbox for the deletion of an activity, add / remove
     * this activity from this.deletion.activities
     * @param {Number} index - The index of the selected activity from this.tips
     * @param {Boolean} state - Whether or not the checkbox is checked
     */
    onChangeDeleteCheckbox(index, state) {
      if (state === true) {
        this.deletion.activities.push(index);
      } else {
        const pos = this.deletion.activities.indexOf(index);
        this.deletion.activities.splice(pos, 1);
      }
    },
    /**
     * Delete all the activities in the `this.deletion.activities` array
     */
    deleteActivities() {
      console.log('On deleteActivities');
      // Set the loading state to the submit button
      this.deletion.loading = true;

      // Get the Google Storage keys of the activities to remove
      const activityKeys = [];
      for (let i = 0; i < this.deletion.activities.length; i++) {
        activityKeys.push(this.premiumActs[this.deletion.activities[i]].key);
      }

      console.log('activityKeys:', activityKeys);

      const data = {
        keys: activityKeys,
      };

      console.log('data:', data);

      axios({
        method: 'DELETE',
        url: `${this.apiUrl}/premium-activations`,
        data,
        headers: {
          Authorization: this.$idToken,
          'content-type': 'application/json',
        },
      })
      .then((result) => {
        console.log('result:', result);

        // Notify the user that the update was successfull
        this.$notify.success({
          title: 'Deletion successfull',
          message: 'The selected activities has been deleted',
        });

        // Hide the deletion UI
        this.deletion = {
          activities: [],
          loading: false,
          active: false,
        };

        // Update the tip list
        axios({
          method: 'GET',
          url: `${this.apiUrl}/premium-activations`,
          headers: {
            Authorization: this.$idToken,
          },
        })
        .then((activities) => {
          this.premiumActs = activities.data;
        }, (error) => {
          console.error(error);
        });
      })
      .catch((error) => {
        console.error(error);
        // Notify the user that an error occurred
        this.$notify.error({
          title: 'Error',
          message: 'An error has occurred, please contact the administrator',
        });

        this.deletion = {
          activities: [],
          loading: false,
          active: false,
        };
      });
    },
    /**
     * Handle the changes on the file input for the premium activation logo
     * @param {Object} file - The submited file
     * @param {Array} fileList - The list of files for this upload component
     */
    onChangeLogo(file, fileList) {
      const typeError = { title: 'Error', message: 'Only png files are allowed' };
      const dimError = { title: 'Error', message: 'The logo dimension must have a height of 44px (width of 170px recommended)' };
      const sizeError = { title: 'Error', message: 'The file size can\'t exceed 1 Mo' };

      // Check the type of the file
      if (file.raw.type !== 'image/png') {
        // Notify the user that an error occurred
        this.$notify.error(typeError);
        // Remove the file preview
        if (this.editing !== false) {
          this.$refs[`logoUpload${this.editing}`][0].clearFiles();
        } else {
          this.$refs.logoUpload.clearFiles();
        }
      }

      // Check dimensions of the uploaded image
      const reader = new FileReader();
      reader.onload = (e) => {
        const image = new Image();
        image.src = e.target.result;

        image.onload = () => {
          if (image.height !== 44) {
            // Notify the user that an error occurred
            this.$notify.error(dimError);
            // Remove the file preview
            if (this.editing !== false) {
              // If editing an existing marketing activity
              this.$refs[`logoUpload${this.editing}`][0].clearFiles();
            } else {
              // If editing a new marketing activity
              this.$refs.logoUpload.clearFiles();
            }
          }
        };
      };
      reader.readAsDataURL(file.raw);
    },
    /**
     * Triggers when the selected languages changes
     * @param {String} languages - current selected value
     */
    onChangeLanguages(languages) {
      // Check if a language has been removed and if yes, remove it from the
      // marketing activity contents

      // If we are editing an existing marketing activity
      if (this.editing !== false) {
        const contents = Object.entries(this.premiumActs[this.editing].contents);
        for (let i = 0; i < contents.length; i++) {
          const language = contents[i][0];
          if (languages.indexOf(language) === -1) {
            delete this.premiumActs[this.editing].contents[language];
          }
        }
      } else {
        // If editing a new marketing activity
        const contents = Object.entries(this.newPremiumAct.contents);
        for (let i = 0; i < contents.length; i++) {
          const language = contents[i][0];
          if (languages.indexOf(language) === -1) {
            delete this.newPremiumAct.contents[language];
          }
        }
      }

      for (let i = 0; i < languages.length; i++) {
        if (this.editing !== false && !this.premiumActs[this.editing].contents[languages[i]]) {
          // If editing an existing marketing activity
          // and no content for this language, create an empty field
          this.premiumActs[this.editing].contents[languages[i]] = '';
        } else if (!this.newPremiumAct.contents[languages[i]]) {
          // If editing a new marketing activity
          // and no content for this language, create an empty field
          this.newPremiumAct.contents[languages[i]] = '';
        }
      }
    },
    /**
     * Count the number of chars of the given description and prevent the user
     * to add more than the limit
     * @param {Event} e
     */
    countdownContent(e) {
      const limit = 80;
      if (e.target.value.length >= limit) {
        e.preventDefault();
      }
    },
    querySearch(queryString, cb) {
      const psVersions = this.psVersions;
      const results = queryString ? psVersions.filter(this.createFilter(queryString)) : psVersions;
      // call callback function to return suggestions
      cb(results);
    },
    /**
     * @param {String} queryString
     */
    createFilter(queryString) {
      /* eslint-disable arrow-body-style */
      return (psVersions) => {
        return (psVersions.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      console.log(item);
    },
    /**
     * Reset the form
     */
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.newPremiumAct = {
        isLive: false,
        name: '',
        techName: '',
        psVersionFrom: '',
        psVersionTo: '',
        languages: ['EN'],
        contents: { EN: '' },
        visibility: [],
      };
      // Clear the uploaded file list
      this.$refs.logoUpload.clearFiles();
    },
    /**
     * addPremiumActivation
     */
    addPremiumActivation() {
      // Set the loading state on the submit btn
      this.saving = true;

      const data = new FormData();
      data.append('activity', JSON.stringify(this.newPremiumAct));

      // If there is a logo to upload
      if (this.$refs.logoUpload.uploadFiles[0]) {
        // Get the file for the logo
        data.append('file', this.$refs.logoUpload.uploadFiles[0].raw);
      }

      // Insert an activity
      axios({
        method: 'POST',
        url: `${this.apiUrl}/premium-activations`,
        data,
        headers: {
          Authorization: this.$idToken,
          'content-type': 'multipart/form-data',
        },
      })
      .then((result) => {
        // Unset the loading state on the submit btn
        this.saving = false;

        // Clear the form
        this.resetForm('newPremiumActForm');

        // Close the modal
        this.premiumActDialogVisible = false;

        // Notify the user that the creation was successfull
        this.$notify.success({
          title: 'Successfull insert',
          message: 'The new Premium Activation has been added',
        });

        // Update the premium activation list
        axios({
          method: 'GET',
          url: `${this.apiUrl}/premium-activations`,
          headers: {
            Authorization: this.$idToken,
          },
        })
        .then((activities) => {
          this.premiumActs = activities.data;
        }, (error) => {
          console.error(error);
        });
      })
      .catch((error) => {
        console.error('Error:', error);
        // Unset the loading state on the submit btn
        this.saving = false;

        const activity = JSON.parse(data.get('activity'));
        switch (error.response.status) {
          case 401:
            // 401 Unauthorized
            this.$notify.error({
              title: 'Error',
              message: 'You are not authorized to add a new activity',
            });
            break;
          case 403:
            // 403 Forbidden
            this.$notify.error({
              title: 'Error',
              message: `Non-existent bucket or you don't have the permission to
              use it. Please contact your administrator`,
            });
            break;
          case 409:
            // 409 Conflict
            this.$notify.error({
              title: 'Error',
              message: `An activity with the tech name "${activity.techName}"
              already exist`,
            });
            break;
          case 400:
            // Missing or wrong parameter
            if (error.message) {
              this.$notify.error({
                title: 'Error',
                message: 'Missing of wrong information submited',
              });
            }
            break;
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Unknow error. Please contact your administrator',
            });
            break;
        }
      });
    },
    /**
     * At the submit of the form
     */
    updatePremiumActivation() {
      // Set the loading state on the submit btn
      this.saving = this.editing;

      if (this.editing !== false && this.premiumActs[this.editing]) {
        // Format the data to be send
        const data = new FormData();
        data.append('activity', JSON.stringify(this.premiumActs[this.editing]));

        // If there is a logo to upload
        if (this.$refs[`logoUpload${this.editing}`][0].uploadFiles[0]) {
          // Get the file for the logo
          data.append('file', this.$refs[`logoUpload${this.editing}`][0].uploadFiles[0].raw);
        }

        // Update an activity
        axios({
          method: 'PUT',
          url: `${this.apiUrl}/premium-activations`,
          data,
          headers: {
            Authorization: this.$idToken,
            'content-type': 'multipart/form-data',
          },
        })
        .then((result) => {
          const activity = result.data;
          // Update the activity with the new data
          activity.logoUrl = `${activity.logoUrl}?${+new Date()}`;
          this.premiumActs[this.editing] = activity;
          this.premiumActs[this.editing].key = ['Premium', activity.name];

          // Notify the user that the update was successfull
          this.$notify.success({
            title: 'Update successfull',
            message: `${activity.name} has been updated`,
          });

          // Remove the file preview
          this.$refs[`logoUpload${this.editing}`][0].clearFiles();

          // Unset the loading state on the submit btn
          this.saving = false;

          // Close the activity edition panel
          this.editing = false;
        }, (error) => {
          console.error(error);
        });
      }
    },
    /**
     * Determine if an array contains one or more items from another array.
     * @param {array} haystack the array to search.
     * @param {array} arr the array providing items to check for in the haystack.
     * @return {boolean} true|false if haystack contains at least one item from arr.
     */
    findOne(haystack, arr) {
      return arr.some((v) => { // eslint-disable-line
        return haystack.indexOf(v) >= 0;
      });
    },
    /**
     * Apply the user filters
     */
    onApplyFilters() {
      const matchs = [];
      for (let i = 0; i < this.premiumActs.length; i++) {
        const languages = this.premiumActs[i].languages;
        const visibility = this.premiumActs[i].visibility;
        const status = this.premiumActs[i].status;

        // If there is a language filter
        if (
          this.filter.languages.length &&
          !this.findOne(languages, this.filter.languages)
        ) {
          matchs.push(i);
        }

        // If there is a country filter
        if (
          this.filter.countries.length &&
          this.filter.countries[0] !== '' &&
          !this.findOne(visibility, this.filter.countries)
        ) {
          matchs.push(i);
        }

        // If the status is not in the status filter
        if (!this.filter.status.includes(status)) {
          matchs.push(i);
        }
      }

      this.filter.hiddenActivities = matchs;
    },
    /**
     * Clear the filter form
     */
    onClearFilters() {
      this.filter = {
        languages: [],
        countries: [],
        hiddenActivities: [],
        status: ['Off', 'Stand by', 'On'],
      };
    },
  },
};
</script>

<style>
.el-dialog__body {
  text-align: left;
}
</style>

<style lang="sass" scoped>
@import '../sass/variables'

.el-select
  width: 100%
</style>



// WEBPACK FOOTER //
// src/components/Premium.vue